import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';

interface DataTableRowProps {
  item: any,
  additionalInfo?: string
  modalOpen?: any
  selectedItem?: any,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DataTableRow',
  props: {
  item: null,
  additionalInfo: null,
  modalOpen: null,
  selectedItem: null
},
  setup(__props) {

const props = __props;



const hoveredRow = ref(null);
const modalOpen = ref(props.modalOpen);
const selectedItem = ref(props.selectedItem);

const params = computed(() => {
  const { item, additionalInfo } = props;
  return {
    title: item.name || null,
    subtitle: item.externalHook || null,
    additionalInfo: additionalInfo?.length ? additionalInfo : null,
  };
});

watch(() => [props.modalOpen, props.selectedItem], () => {
  modalOpen.value = props.modalOpen;
  selectedItem.value = props.selectedItem;
});

const rowStyle = computed(() => {
  const hasPadding = params.value.subtitle || params.value.additionalInfo;
  return {
    minHeight: '36px',
    padding: hasPadding ? '8px' : '0px', // Apply padding if subtitle or additionalInfo exists
  };
});

return { __sfc: true,props, hoveredRow, modalOpen, selectedItem, params, rowStyle, ref, computed, watch }
}

})